<template>
    <router-view />
</template>

<script>
  export default {
    name: 'Main',
  }
</script>
